module.exports = __webpack_public_path__ + "files/af6ac3b2cc3dca5baff5dde1effae4bd.png";